export const categoryIcons = {
  DocumentAdded: "note_add",
  DataModel: "account_tree",
  TaskComplete: "task",
  Database: "storage",
  CloudUpload: "cloud_upload",
  DataExtract: "insights",
  DataExtractComplete: "trending_up",
  Complete: "check_circle",
  Image: "image",
  Video: "video_library",
  Word: "description",
  Excel: "table_chart",
  Powerpoint: "slideshow",
  Pdf: "picture_as_pdf",
  Text: "text_snippet",
  Audio: "library_music",
  Archive: "archive",
  File: "draft",
};

export const fileExtensionIcons = {
  png: "image",
  jpg: "image",
  webx: "video_library",
  docx: "description",
  xlsx: "table_chart",
  pptx: "slideshow",
  pdf: "picture_as_pdf",
  txt: "text_snippet",
  mp4: "library_music",
  zip: "folder_zip",
  File: "draft",
};
